var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommsBankModalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 28,
    viewBox: "0 0 102 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4530_9149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5498 14.0242C33.5498 10.6726 35.3932 8.94092 37.865 8.94092C39.6804 8.94092 41.2724 9.93243 41.5378 11.8875H39.9876C39.7921 10.6865 38.8565 10.2536 37.8789 10.2536C36.259 10.2536 35.058 11.3429 35.058 14.0242C35.058 16.7054 36.259 17.7947 37.8789 17.7947C38.8565 17.7947 39.7921 17.3618 39.9876 16.1608H41.5378C41.2724 18.1159 39.6804 19.1074 37.865 19.1074C35.3932 19.1074 33.5498 17.3757 33.5498 14.0242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0986 15.3788C42.0986 13.0886 43.5091 11.6362 45.4502 11.6362C47.4053 11.6362 48.8158 13.0886 48.8158 15.3788C48.8158 17.6691 47.4053 19.1214 45.4502 19.1214C43.5091 19.1214 42.0986 17.6691 42.0986 15.3788ZM45.4502 17.9484C46.5674 17.9484 47.3355 17.1105 47.3355 15.3788C47.3355 13.6472 46.5674 12.8093 45.4502 12.8093C44.333 12.8093 43.551 13.6472 43.551 15.3788C43.551 17.1105 44.333 17.9484 45.4502 17.9484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7109 11.8178H51.1633V12.907C51.6241 12.0552 52.4341 11.6362 53.286 11.6362C54.2077 11.6362 55.0176 12.0971 55.3807 13.0467C55.8416 12.0971 56.7074 11.6362 57.671 11.6362C58.9557 11.6362 60.0171 12.4881 60.0171 14.2616V18.9399H58.5647V14.4851C58.5647 13.34 58.048 12.921 57.252 12.921C56.3303 12.921 55.5902 13.6751 55.5902 14.904V18.9399H54.1378V14.4851C54.1378 13.34 53.6211 12.921 52.8251 12.921C51.9034 12.921 51.1633 13.6751 51.1633 14.904V18.9399H49.7109V11.8178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.168 11.8178H62.6203V12.907C63.0812 12.0552 63.8911 11.6362 64.743 11.6362C65.6647 11.6362 66.4747 12.0971 66.8377 13.0467C67.2986 12.0971 68.1644 11.6362 69.128 11.6362C70.4128 11.6362 71.4741 12.4881 71.4741 14.2616V18.9399H70.0217V14.4851C70.0217 13.34 69.505 12.921 68.709 12.921C67.7874 12.921 67.0472 13.6751 67.0472 14.904V18.9399H65.5949V14.4851C65.5949 13.34 65.0782 12.921 64.2822 12.921C63.3605 12.921 62.6203 13.6751 62.6203 14.904V18.9399H61.168V11.8178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5967 9.1084H76.8281C78.5876 9.1084 79.7048 10.072 79.7048 11.65C79.7048 12.7114 79.1742 13.4515 78.3642 13.8286C79.3557 14.1637 79.9841 15.0435 79.9841 16.1328C79.9841 17.9203 78.7971 18.9397 76.6884 18.9397H72.5967V9.1084ZM76.5488 13.2979C77.638 13.2979 78.2385 12.8091 78.2385 11.8455C78.2385 10.8819 77.638 10.3932 76.5488 10.3932H74.049V13.2979H76.5488ZM76.7443 17.6549C77.8894 17.6549 78.5178 17.1243 78.5178 16.1188C78.5178 15.1133 77.8894 14.5827 76.7443 14.5827H74.049V17.6549H76.7443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.584 16.8172C80.584 15.4487 81.6593 14.7085 83.0139 14.6527L85.2343 14.5689V14.2197C85.2343 13.312 84.7595 12.8093 83.8099 12.8093C82.8323 12.8093 82.4134 13.2282 82.2598 13.8427H80.7097C81.0029 12.4043 82.1341 11.6362 83.8239 11.6362C85.6114 11.6362 86.6168 12.5998 86.6168 14.122V17.2501C86.6168 17.6691 86.8403 17.8646 87.1754 17.8646C87.2453 17.8646 87.3011 17.8646 87.4128 17.8506V18.9678C87.1475 19.0237 86.966 19.0377 86.7425 19.0377C86.0303 19.0377 85.4997 18.7304 85.3181 18.088C84.8992 18.7304 84.0194 19.1214 83.0697 19.1214C81.4777 19.1214 80.584 18.102 80.584 16.8172ZM83.4328 17.9763C84.4383 17.9763 85.2343 17.4177 85.2343 16.4262V15.6302L83.2653 15.728C82.4553 15.7699 82.0224 16.105 82.0224 16.7474C82.0224 17.4875 82.4972 17.9763 83.4328 17.9763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9824 11.8178H89.4348V12.9489C89.9235 12.0412 90.7614 11.6362 91.6831 11.6362C92.9819 11.6362 94.0991 12.4881 94.0991 14.2616V18.9399H92.6467V14.6247C92.6467 13.3818 92.0462 12.921 91.2223 12.921C90.3285 12.921 89.4348 13.5075 89.4348 14.9459V18.9399H87.9824V11.8178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2217 18.9402V9.10889H96.674V15.1836L99.5648 11.8181H101.324L98.294 15.2674L101.324 18.9402H99.481L96.674 15.4769V18.9402H95.2217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5742 0L28.5742 14L14.5742 28L0.574219 14L14.5742 0Z",
    fill: "url(#paint0_linear_4530_9149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8898 15.4174L14.5742 27.9999L28.5742 13.9999L24.9386 10.3599L19.8898 15.4174Z",
    fill: "url(#paint1_linear_4530_9149)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4530_9149",
    x1: 6.35726,
    y1: 7.10657,
    x2: 22.7912,
    y2: 20.8934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FEF10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FDE516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FDE113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FED508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4530_9149",
    x1: 17.605,
    y1: 17.8341,
    x2: 22.7106,
    y2: 21.0278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#874400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D88A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E79D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2B400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FAD202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEDF03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4530_9149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100.751,
    height: 28,
    fill: "white",
    transform: "translate(0.574219)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommsBankModalLogo);
export default __webpack_public_path__ + "static/media/commsBankModalLogo.1e23598c695b2ed2ceb282085c424d06.svg";
export { ForwardRef as ReactComponent };